export default __webpack_public_path__ + "images/0V.e0c9bea.png";